export default "__VITE_ASSET__DN6Kp88m__"